import { render, staticRenderFns } from "./photoView.vue?vue&type=template&id=140f6d31&scoped=true&"
import script from "./photoView.vue?vue&type=script&lang=js&"
export * from "./photoView.vue?vue&type=script&lang=js&"
import style0 from "./photoView.vue?vue&type=style&index=0&id=140f6d31&scoped=true&lang=css&"
import style1 from "./photoView.vue?vue&type=style&index=1&id=140f6d31&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140f6d31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('140f6d31')) {
      api.createRecord('140f6d31', component.options)
    } else {
      api.reload('140f6d31', component.options)
    }
    module.hot.accept("./photoView.vue?vue&type=template&id=140f6d31&scoped=true&", function () {
      api.rerender('140f6d31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/photoView.vue"
export default component.exports